// extracted by mini-css-extract-plugin
module.exports = {"error":"ErrorModal_error__287UC"};